import { SettingsDataService } from '../../DataService/SettingsDataService';
import { AddOrUpdateSetting } from '../../Models/Setting/AddOrUpdateSetting';

export class SettingsManager {

    constructor(private containerElement: JQuery) { }
    
    private settingDefinitions;
    private settingValues;

    private settingDisplayName : JQuery<HTMLElement>;
    private settingDescription : JQuery<HTMLElement>;

    public initialize() {
        var self = this;

        self.settingDisplayName = self.containerElement.find('#setting-display-name');
        self.settingDescription = self.containerElement.find('#setting-description');

        self.renderSidebar();
    }

    private getUniqueGroups(definitions) : any {
        var self = this;

        return [...new Set(definitions.map(d => d.group))];
    }

    private renderSidebar() {
        var self = this;

        const $list = $('#setting-categories');

        SettingsDataService.getSettingDefinitionsWithValues((settingDefinitionsWithValues) => {
            self.settingDefinitions = settingDefinitionsWithValues.settingDefinitions;
            self.settingValues = settingDefinitionsWithValues.settingValues;

            $list.empty();

            var uniqueGroups = self.getUniqueGroups(self.settingDefinitions);

            uniqueGroups.forEach((group : any) => {
                const $li = $('<li>')
                .text(group)
                .off('click')
                .on('click', () => {
                    $list.find('li.active').removeClass('active');
                    $li.addClass('active');

                    self.renderSettings(group)
                });
                $list.append($li);
            });

            $list.children().first().trigger('click');
        })


    }

    private renderSettings(group) {
        var self = this;
        const $container = $('#settings-container').empty();

        const settings = self.settingDefinitions.filter(s => s.group === group);

        const subgroupMap = {};
        settings.forEach(setting => {
            const subgroup = setting.subGroup || group;
            if (!subgroupMap[subgroup]) {
                subgroupMap[subgroup] = [];
            }
            subgroupMap[subgroup].push(setting);
        });

        Object.entries(subgroupMap).forEach(([subgroupName, subgroupSettings]) => {
            const $subgroupDiv = $('<div>').addClass('settings-sub-group');
            $subgroupDiv.append('<div class="collapse-filler">');

            const $subgroupSettingsContainer = $('<div>').addClass('settings-group-container');
            const $subgroupTitle = $('<h5>').addClass('settings-sub-group-title').text(subgroupName);
            $subgroupSettingsContainer.append($subgroupTitle);

            (subgroupSettings as any).forEach(setting => {
                const $settingDiv = $('<div>').addClass('setting').attr('data-key', setting.key);
                const $label = $('<label>').addClass('setting-key').text(setting.displayName);
                $label.off('click').on('click', () => {
                    $container.find('.setting-key.active').removeClass('active');
                    $label.addClass('active');

                    self.setSettingInformation(setting.displayName, setting.description);
                })
                const $inputDiv = $('<div>').addClass('input-container');
                let $input;

                const value = self.getSettingValue(setting.key);

                switch (setting.type) {
                    case 'Boolean':
                        $input = $('<select>');
                        $input.append($('<option>').text('True').val('True'));
                        $input.append($('<option>').text('False').val('False'));
                        $input.val(value)
                            .off('change')
                            .on('change', () => {
                                self.updateSettingValue(setting.key, $input.val());
                                self.updateDependencies();
                            });
                        break;

                    case 'Text':
                        $input = $('<input type="text">')
                            .val(value)
                            .off('change')
                            .on('change', () => {
                                var value = $input.val();
                                if(value.trim().length === 0) {
                                    value = setting.defaultValue;
                                    $input.val(value);
                                }

                                self.updateSettingValue(setting.key, value);
                                self.updateDependencies();
                            });
                        break;

                    case 'Dropdown':
                        $input = $('<select>');
                        setting.options.forEach(opt => {
                            $input.append($('<option>').text(opt).val(opt));
                        });
                        $input.val(value)
                            .off('change')
                            .on('change', () => {
                                self.updateSettingValue(setting.key, $input.val());
                                self.updateDependencies();
                            });
                        break;
                }

                $input.attr('id', setting.key);
                $inputDiv.append($input);
                $settingDiv.append($label).append($inputDiv);
                $subgroupSettingsContainer.append($settingDiv)
                $subgroupDiv.append($subgroupSettingsContainer);
            });

            $container.append($subgroupDiv);
            $container.find('.setting-key').first().trigger('click');
        });

        self.updateDependencies();
    }

    private updateDependencies() {
        var self = this;
        const currentValues = {};

        $('.setting').each(function () {
            const key = $(this).data('key');
            const $input = $(this).find('input, select');
            let value;

            if ($input.is(':checkbox')) {
                value = $input.is(':checked').toString();
            } else {
                value = $input.val();
            }

            currentValues[key] = value;
        });

        this.settingDefinitions.forEach(setting => {
            if (!setting.dependencies) return;

            let enabled = true;

            setting.dependencies.forEach(dep => {
                const actualValue = currentValues[dep.dependentKey];
                if (dep.action === "Enable" && actualValue !== dep.expectedValue) {
                    enabled = false;
                }
            });

            const $target = $(`#${setting.key}`);
            $target.closest('.setting').toggleClass('disabled', !enabled);
            $target.prop('disabled', !enabled);
        });
    }

    private updateSettingValue(key, value) {
        var self = this;

        var addOrUpdateModel = new AddOrUpdateSetting();
        addOrUpdateModel.settingKey = key;
        addOrUpdateModel.settingValue = value;

        SettingsDataService.addOrUpdateSettingValue(addOrUpdateModel, (result) => {
            const existing = self.settingValues.find(s => s.key === key);
            if (existing) {
                existing.value = value;
            } else {
                this.settingValues.push({ key, value: value });
            }
        })
    }

    private getSettingValue(key: string): string {
        var self = this;
        const entry = self.settingValues.find(s => s.key === key);
        return entry ? entry.value : "";
    }

    private setSettingInformation(displayName: string, description: string) {
        var self = this;

        self.settingDisplayName.text(displayName);
        self.settingDescription.html(description);
    }



}